/* eslint-disable react-hooks/exhaustive-deps */
import { useLiveQuery } from "dexie-react-hooks";
import { useEffect, useMemo, useState } from "react";
import { db } from "~/db/db";
import useSelect from "~components/Form/hooks/useSelect";
import prepareForOptions from "~services/utils/prepareForOptions";

const useNivelServico = ({ formikRef, name = "nivelServicoId" }) => {
  const nivelServicoSelect = useSelect("nivelServico");
  const [nivelServico, setNivelServico] = useState(0);

  const [nivelServicos, setNivelServicos] = useState([]);

  useEffect(() => {
    const fetchNivelServicos = async () => {
      const result = [];
      await db.niveisServico.each((item) => result.push(item));
      setNivelServicos(result);
    };

    fetchNivelServicos();
  }, []);



  const optionNivelServicos = useMemo(() => prepareForOptions(nivelServicos, ['nome'], 'id'), [nivelServicos]);

  function onChangeNivelServico(e) {
    nivelServicoSelect.upDateValue(e.value);
    nivelServicoSelect.upDateDefaultValue(e || "");
    formikRef.current.setFieldValue(name, e.value);
    setTimeout(() => formikRef.current.setFieldTouched(name, true));
    setNivelServico(e.value);
  }

  function SetSelectNivelServico(id) {
    const nivelServico = optionNivelServicos.find((o) => o.value === id);
    if (nivelServico)
      onChangeNivelServico(nivelServico);
  }

  return {
    nivelServicos,
    optionNivelServicos,
    onChangeNivelServico,
    SetSelectNivelServico,
    nivelServico,
    nivelServicoSelect,
    setNivelServico
  };
}

export default useNivelServico;